import React, { useEffect, useState } from 'react';
import { utcIsoDateToLocaleDate } from '../../../../../utils/date';
import NumberFormat from 'react-number-format';
import { Auftrag, Auftragsposition, Lademittel } from '../../../../../api';
import { addDecimalNumbers } from '../../../../../utils/mathUtils';
import { AuftragDefaultServiceModel } from '../../../../../models/AuftragDefaultServiceModel';

interface AuftragsresearchProps {
  selectedAuftrag: Auftrag | undefined;
  dynamicServices: AuftragDefaultServiceModel[]; //#84840
}

/**
 * AuftragSidebarTab-Component
 *
 * Dient zur Anzeige von Auftragsinformationen
 *
 * @returns {JSX.Element} AuftragSidebarTab-Component
 * @constructor
 */
const AuftragSidebarTab = (props: AuftragsresearchProps) => {
  const [anzahlVerpackungen, setAnzahlVerpackungen] = useState(0);
  const [lademittel, setLademittel] = useState({});
  const [bruttogewicht, setBruttogewicht] = useState(0.0);
  const [lademeter, setLademeter] = useState(0.0);
  const [kubikmeter, setKubikmeter] = useState(0.0);
  const [stellplaetze, setStellplaetze] = useState(0);

  useEffect(() => {
    updateLocalState();
  }, [props.selectedAuftrag]);

  const updateLocalState = () => {
    let verpackungAnzahl = 0;
    let tmpLademittel = {};
    let bruttogewicht = 0.0;
    let lademeter = 0.0;
    let kubikmeter = 0.0;
    let stellplaetze = 0;
    props.selectedAuftrag?.auftragspositionen?.map(
      (auftragPos: Auftragsposition) => {
        if (auftragPos.verpackungAnzahl) {
          verpackungAnzahl += auftragPos.verpackungAnzahl;
        }
        if (auftragPos.bruttoGewicht) {
          bruttogewicht += auftragPos.bruttoGewicht;
        }
        if (auftragPos.lademeter) {
          lademeter += auftragPos.lademeter;
        }
        if (auftragPos.volumenCBM) {
          kubikmeter += auftragPos.volumenCBM;
        }
        if (auftragPos.stellplaetze) {
          stellplaetze = addDecimalNumbers([
            stellplaetze,
            Number(auftragPos.stellplaetze),
          ]);
        }
        if (auftragPos.lademittel && auftragPos.lademittelAnzahl) {
          tmpLademittel = addLademittel(
            tmpLademittel,
            auftragPos.lademittel,
            auftragPos.lademittelAnzahl
          );
        }
      }
    );
    setAnzahlVerpackungen(verpackungAnzahl);
    setLademittel(tmpLademittel);
    setBruttogewicht(bruttogewicht);
    setLademeter(lademeter);
    setKubikmeter(kubikmeter);
    setStellplaetze(stellplaetze);
  };

  const addLademittel = (
    tmpLademittel: any,
    lademittelObject: Lademittel,
    lademittelAnzahl: number
  ) => {
    if (!isNaN(lademittelAnzahl) && lademittelObject.langBezeichnung) {
      if (tmpLademittel.hasOwnProperty(lademittelObject.langBezeichnung)) {
        tmpLademittel[lademittelObject.langBezeichnung] += lademittelAnzahl;
      } else {
        tmpLademittel[lademittelObject.langBezeichnung] = lademittelAnzahl;
      }
    }
    return tmpLademittel;
  };

  const getListOfAllInhalt = (): string[] => {
    const inhalt: string[] = [];
    props.selectedAuftrag?.auftragspositionen?.map(
      (auftragpos: Auftragsposition) => {
        if (auftragpos.warengutBezeichnung != null) {
          inhalt.push(auftragpos.warengutBezeichnung);
        }
      }
    );

    return inhalt;
  };
  //#84840
  const getListOfServices = (): string[] => {
    const inhalt: string[] = [];
    if (
      props.selectedAuftrag?.auftragServices &&
      props.selectedAuftrag?.auftragServices?.length > 0
    ) {
      props.selectedAuftrag?.auftragServices.forEach(service => {
        const dynamicService = props.dynamicServices.find(
          ds => ds.spezNum === service.spez_num
        );
        let wert = '';
        if (dynamicService?.typ !== 'Logisch') {
          wert = ': ' + service.wert;
        }
        inhalt.push(`${dynamicService?.bezkurz}${wert}`);
      });
    }
    return inhalt;
  };

  return (
    <div className={'tab-content'}>
      <div className={'info-block'}>
        <p className={'fs-16-5'}>
          <strong>{props.selectedAuftrag?.spedeigennr ?? ''}</strong>
        </p>
      </div>

      {/*Versender*/}
      <div className={'info-block'}>
        <label className={'info-label'}>{'Versender'}</label>
        <p>
          {props.selectedAuftrag?.absenderAdresse?.matchcode ?? ''}
          {props.selectedAuftrag?.spedfremdnr
            ? ', ' + props.selectedAuftrag?.spedfremdnr
            : ''}
        </p>
        <p>{props.selectedAuftrag?.absenderAdresse?.name ?? ''}</p>
        <p>
          {props.selectedAuftrag?.absenderAdresse?.strasse ?? ''}{' '}
          {props.selectedAuftrag?.absenderAdresse?.hausnummer ?? ''}
        </p>
        <p>
          {props.selectedAuftrag?.absenderAdresse?.plz ?? ''}{' '}
          {props.selectedAuftrag?.absenderAdresse?.ort ?? ''}
        </p>
      </div>
      {/*Todo Versender Kontakt + Telefonnummer oder E-Mail Adresse*/}

      {/*Empfaenger*/}
      <div className={'info-block'}>
        <label className={'info-label'}>{'Empfänger'}</label>
        <p>
          {props.selectedAuftrag?.empfaengerAdresse?.matchcode ?? ''}
          {props.selectedAuftrag?.empfaengerAdresse?.fremdnummer
            ? ', ' + props.selectedAuftrag?.empfaengerAdresse?.fremdnummer
            : ''}
        </p>
        <p>{props.selectedAuftrag?.empfaengerAdresse?.name ?? ''}</p>
        <p>
          {props.selectedAuftrag?.empfaengerAdresse?.strasse ?? ''}{' '}
          {props.selectedAuftrag?.empfaengerAdresse?.hausnummer ?? ''}
        </p>
        <p>
          {props.selectedAuftrag?.empfaengerAdresse?.plz ?? ''}{' '}
          {props.selectedAuftrag?.empfaengerAdresse?.ort ?? ''}
        </p>
        {/*Todo Empfaenger Kontakt + Telefonnummer oder E-Mail Adresse*/}
      </div>

      {/*Versanddaten*/}
      {props.selectedAuftrag?.terminkennzeichen?.langBezeichnung ||
      props.selectedAuftrag?.abholDatumVon ||
      props.selectedAuftrag?.anlieferkennzeichen?.langBezeichnung ||
      props.selectedAuftrag?.zustellDatumVon ||
      props.selectedAuftrag?.zustellkennzeichen?.langBezeichnung ? (
        <div className={'info-block'}>
          <label className={'info-label'}>{'Versanddaten'}</label>
          <p>
            {props.selectedAuftrag?.terminkennzeichen
              ? 'Terminart: ' +
                props.selectedAuftrag.terminkennzeichen.langBezeichnung
              : ''}
          </p>
          <p>
            {props.selectedAuftrag?.abholDatumVon
              ? 'Versanddatum: ' +
                utcIsoDateToLocaleDate(props.selectedAuftrag.abholDatumVon) +
                ' '
              : ''}
          </p>
          <p>
            {props.selectedAuftrag?.anlieferkennzeichen
              ? 'Anlieferart: ' +
                props.selectedAuftrag.anlieferkennzeichen.langBezeichnung
              : ''}
          </p>
          <p>
            {props.selectedAuftrag?.zustellDatumVon
              ? 'Zustelldatum: ' +
                utcIsoDateToLocaleDate(props.selectedAuftrag.zustellDatumVon)
              : ''}
          </p>
          <p>
            {props.selectedAuftrag?.zustellkennzeichen
              ? 'Zustellart: ' +
                props.selectedAuftrag.zustellkennzeichen.langBezeichnung
              : ''}
          </p>
        </div>
      ) : (
        ''
      )}

      {/*Senungspos, Lademittel etc*/}
      <div className={'info-block'}>
        <label className={'info-label'}>{'Inhalt'}</label>
        {getListOfAllInhalt().map((value: string, index: number) => {
          return <p key={index}>{value}</p>;
        })}
      </div>
      <div className={'info-block'}>
        <label className={'info-label'}>{'Übersicht'}</label>
        <p>
          {anzahlVerpackungen} {'Verpackungen'}
        </p>
        {Object.entries(lademittel).map(([key, value]) => (
          <p key={key}>
            {value} {key}
          </p>
        ))}
        <NumberFormat
          value={bruttogewicht}
          displayType={'text'}
          thousandSeparator={'.'}
          decimalSeparator={','}
          suffix={' kg'}
        />
        <br />
        <NumberFormat
          value={lademeter}
          displayType={'text'}
          thousandSeparator={'.'}
          decimalSeparator={','}
          suffix={' LDM'}
        />
        <br />
        <NumberFormat
          value={kubikmeter}
          displayType={'text'}
          thousandSeparator={'.'}
          decimalSeparator={','}
          suffix={' cbm'}
        />
        <br />
        <NumberFormat
          value={stellplaetze}
          displayType={'text'}
          thousandSeparator={'.'}
          decimalSeparator={','}
          suffix={' STP'}
        />
      </div>
      {getListOfServices().length > 0 ? (
        <div className={'info-block'}>
          <label className={'info-label'}>{'Services'}</label>
          {getListOfServices().map((value: string, index: number) => {
            return <p key={index}>{value}</p>;
          })}
        </div>
      ) : (
        ''
      )}
    </div>
  );
};

export default AuftragSidebarTab;
